import LayoutAdmin from "view/ExampleLayout/Admin";
import AllInput from "view/Template/AllInput";
import RoleForm from "view/Admin/AdminUser/Role/RoleForm";
import RoleList from "view/Admin/AdminUser/Role/RoleList";
import GroupForm from "view/Admin/AdminUser/Group/GroupForm";
import GroupList from "view/Admin/AdminUser/Group/GroupList";
import Indicator from "view/Admin/Indicator/Indicator";
// import IndicatorForm from "view/Admin/Indicator/IndicatorForm";
import PublishDocList from "view/Admin/PublishDoc/PublishDocList";
import PublishDocForm from "view/Admin/PublishDoc/PublishDocForm";
import UserForm from "view/Admin/AdminUser/User/UserForm";
import UserList from "view/Admin/AdminUser/User/UserList";
import HistoryReport from "view/Admin/HistoryReport/HistoryReport";
import ReportLeave from "view/Backend/Leave/ReportLeave";
import HolidayManagement from "view/Admin/HolidayManagement/HolidayManagement";
import GalleryList from "view/Admin/Gallery/GalleryList";
import GalleryForm from "view/Admin/Gallery/GalleryForm";
import HolidayManagementForm from "view/Admin/HolidayManagement/HolidayManagementForm";
import LeaveList from "view/Backend/Leave/LeaveList";
import LeaveFrom from "view/Backend/Leave/LeaveFrom";
import LeaveRights from "view/Admin/LeaveRights/LeaveRights";
import LeaveRightsForm from "view/Admin/LeaveRights/LeaveRightsForm";
import BannerList from "view/Admin/AdminBanner/BannerList";
import BannerForm from "view/Admin/AdminBanner/BannerForm";
import TimeAttendanceDetail from "view/Backend/TimeAttendance/TimeAttendanceDetail";
import TimeAttendanceEdit from "view/Backend/TimeAttendance/TimeAttendanceEdit";
import TestPage from "view/ExampleLayout/Admin/GroupList";
import EmploymentSummary from "view/Backend/EmploymentSummary/EmploymentSummary";
import SaveWorkingStatusForm from "view/Backend/TimeAttendance/SaveWorkingStatusForm";
import SaveWorkingStatusList from "view/Backend/TimeAttendance/SaveWorkingStatusList";
import ReportList from "view/Backend/OperationalReport/ReportList";
import MaterialForm from "view/Admin/Material/MaterialForm";
import GallerySettingList from "view/Admin/Gallery/GallerySettingList";

import ProjectList from "view/Backend/Project/ProjectList";
import ProjectsRequestingFrom from "view/Backend/Project/ProjectsRequestingFrom";
import ProjectCheckRecordList from "view/Backend/Project/ProjectCheckRecord/ProjectCheckRecordList";
import ProjectCheckRecordFrom from "view/Backend/Project/ProjectCheckRecord/ProjectCheckRecordFrom";
import ProjectArrangeOrder from "view/Backend/Project/ProjectArrangeOrder/ProjectArrangeOrder";

import MaterialList from "view/Admin/Material/MaterialList";
import BasicInformationList from "view/Admin/BasicInformation/BasicInformationList";
import ProjectTimelineForm from "view/Admin/ProjectRegisterTimeline/ProjectTimelineForm";
import ProjectTimelineList from "view/Admin/ProjectRegisterTimeline/ProjectTimelineList";
import GallerySettingForm from "view/Admin/Gallery/GallerySettingForm";
import SupplyTicket from "view/Backend/IncomeExpenses/Ticket/SupplyTicket";
import ReceiveTicketForm from "view/Backend/IncomeExpenses/Ticket/Receive/ReceiveTicketForm";
import WithdrawTicketForm from "view/Backend/IncomeExpenses/Ticket/Withdraw/WithdrawTicketForm";
import CommitteeList from "view/Admin/Committee/CommitteeList";
import CommitteeForm from "view/Admin/Committee/CommitteeForm";
import MaterialReceiveForm from "view/Backend/MaterialInventory/MaterialReceiveForm";
import { TicketSoldList } from "view/Backend/IncomeExpenses/Ticket/TicketSold/TicketSoldList";
import { TicketSoldForm } from "view/Backend/IncomeExpenses/Ticket/TicketSold/TicketSoldForm";
import FundActionPlanList from "view/Backend/FundPlan/FundActionPlan/FundActionPlanList";
import FundActionPlanForm from "view/Backend/FundPlan/FundActionPlan/FundActionPlanForm";
import MaterialInventoryList from "view/Backend/MaterialInventory/MaterialInventoryList";
import MaterialWithdrawForm from "view/Backend/MaterialInventory/MaterialWithdrawForm";
import CommitteeTicketList from "view/Backend/IncomeExpenses/Ticket/CommitteeTicket/CommitteeTicketList";
import { CommitteeTicketForm } from "view/Backend/IncomeExpenses/Ticket/CommitteeTicket/CommitteeTicketForm";
import AccountingPaymentList from "view/Backend/IncomeExpenses/Ticket/AccountingPayment/AccountingPaymentList";
import AccountingPaymentForm from "view/Backend/IncomeExpenses/Ticket/AccountingPayment/AccountingPaymentForm";
import AccountingFundForm from "view/Backend/IncomeExpenses/Ticket/AccountingFund/AccountingFundForm";
import AccountingFundList from "view/Backend/IncomeExpenses/Ticket/AccountingFund/AccountingFundList";
import MaterialReturnForm from "view/Backend/MaterialInventory/MaterialReturnForm";
// import MaterialWithdrawBorrowForm from "view/Backend/MaterialInventory/MaterialWithdrawBorrowForm";
// import FollowUp from "view/Backend/FundPlan/FollowUp/FollowUp";
// import ProgressReport from "view/Backend/FundPlan/FollowUp/Report";

// import FollowUpReview from "view/Backend/FundPlan/FollowUp/FollowUpReview";
import FundIncomePlanList from "view/Backend/IncomeExpenses/FundIncomePlan/FundIncomePlanList";
import FundIncomePlanForm from "view/Backend/IncomeExpenses/FundIncomePlan/FundIncomePlanForm";
import UserSystemList from "view/Admin/UserSystem/UserSystemList";
import UserSystemForm from "view/Admin/UserSystem/UserSystemForm";
import FundExpensesPlanList from "view/Backend/IncomeExpenses/FundExpensesPlan/FundExpensesPlanList";
import FundExpensesPlanForm from "view/Backend/IncomeExpenses/FundExpensesPlan/FundExpensesPlanForm";
import FollowUp from "view/Backend/FundPlan/FollowUp/FollowUp";
import FollowUpReview from "view/Backend/FundPlan/FollowUp/FollowUpReview";
import ProgressReport from "view/Backend/FundPlan/FollowUp/Report";
import ReportIncomeExpense from "view/Backend/ReportIncomeExpense/ReportIncomeExpense";
import MaterialWithdrawBorrowForm from "view/Backend/MaterialInventory/MaterialWithdrawBorrowForm";
// import FunTest from "view/Admin/Indicator/FunTest";
import EquipmentList from "view/Backend/Equipment/EquipmentList";
import EquipmentReceiveForm from "view/Backend/Equipment/EquipmentReceiveForm";
import EquipmentWithdrawForm from "view/Backend/Equipment/EquipmentWithdrawForm";

import IndicatorForm from "view/Admin/Indicator/IndicatorForm";
import FunTestcopy from "view/Admin/Indicator/FunTestcopy";
import FundExpenseActualList from "view/Backend/IncomeExpenses/FundExpensesActual/FundExpenseActualList";
import FundExpenseActualForm from "view/Backend/IncomeExpenses/FundExpensesActual/FundExpenseActualForm";
import FundIncomeActualList from "view/Backend/IncomeExpenses/FundIncomeActual/FundIncomeActualList";
import FundIncomeActualForm from "view/Backend/IncomeExpenses/FundIncomeActual/FundIncomeActualForm";
import FollowUpApprove from "view/Backend/FundPlan/FollowUp/FollowUpApprove";
import EquipmentReturnForm from "view/Backend/Equipment/EquipmentReturnForm";
import HomeAdmin from "view/Admin/HomeAdmin";
import FundPlanCalendar from "view/Backend/FundPlan/FundActionPlan/FundPlanCalendar";
import ReportParcel from "view/Backend/ReportParcel/ReportParcel";
import FundPlanGanttChart from "view/Backend/FundPlan/FundActionPlan/FundPlanGanttChart";
import FundActivityGraph from "view/Backend/FundPlan/FundActivityGraph/FundActivityGraph";
import MigrateProject from "view/FrontEnd/Dashboard/ProjectSupport/MigrateProject/MigrateProject";
import MigrationDataProject from "view/Backend/Project/Migration/MigrationDataProject";
import EquipmentCusoffForm from "view/Backend/Equipment/EquipmentCusoffForm";
import FundAccoutingForm from "view/Backend/IncomeExpenses/FundAccouting/FundAccoutingForm";
import FundAccoutingList from "view/Backend/IncomeExpenses/FundAccouting/FundAccoutingList";
import ReportTicketFund from "view/Backend/ReportIncomeExpense/ReportTicketFund";
import { ETicket } from "view/Backend/ETicket/ETicket";
import { ImportETicket } from "view/Backend/ETicket/ImportETicket";
import { ChangeFileTicketSold } from "view/Backend/ChangeFileTicketSold/ChangeFile";
const route = [
  {
    exact: true,
    path: "/HomeBack",
    component: AllInput,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/RoleList",
    component: RoleList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/RoleForm",
    component: RoleForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/indicator",
    component: Indicator,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/indicatorform",
    component: IndicatorForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/GroupList",
    component: GroupList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/GroupForm",
    component: GroupForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/PublishDocList",
    component: PublishDocList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/PublishDocForm",
    component: PublishDocForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/UserList",
    component: UserList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/UserForm",
    component: UserForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/HistoryReport",
    component: HistoryReport,
    layout: LayoutAdmin,
  },

  {
    exact: true,
    path: "/ReportLeave",
    component: ReportLeave,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/HolidayManagement",
    component: HolidayManagement,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/GalleryList",
    component: GalleryList,
    layout: LayoutAdmin,
  },
  {
    path: "/HolidayManagementForm",
    component: HolidayManagementForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/GalleryForm",
    component: GalleryForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/LeaveList",
    component: LeaveList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/LeaveFrom",
    component: LeaveFrom,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/LeaveRights",
    component: LeaveRights,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/LeaveRightsForm",
    component: LeaveRightsForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/BannerList",
    component: BannerList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/BannerForm",
    component: BannerForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/TimeAttendanceDetail",
    component: TimeAttendanceDetail,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/TimeAttendanceEdit",
    component: TimeAttendanceEdit,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/TestPage",
    component: TestPage,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/EmploymentSummary",
    component: EmploymentSummary,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/SaveWorkingStatusList",
    component: SaveWorkingStatusList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/SaveWorkingStatusForm",
    component: SaveWorkingStatusForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/OperationalReport",
    component: ReportList,
    layout: LayoutAdmin,
  },

  {
    exact: true,
    path: "/MaterialForm",
    component: MaterialForm,
    layout: LayoutAdmin,
  },
  {
    path: "/GallerySettingList",
    component: GallerySettingList,
    layout: LayoutAdmin,
  },
  {
    path: "/GallerySettingForm",
    component: GallerySettingForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectList",
    component: ProjectList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectsRequestingFrom",
    component: ProjectsRequestingFrom,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectCheckRecordList",
    component: ProjectCheckRecordList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectCheckRecordFrom",
    component: ProjectCheckRecordFrom,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectArrangeOrder",
    component: ProjectArrangeOrder,
    layout: LayoutAdmin,
  },
  // {
  // 	exact: true,
  // 	path: "/ProjectProposalList",
  // 	component: ProjectProposalList,
  // 	layout: LayoutAdmin
  // },
  // {
  // 	exact: true,
  // 	path: "/ProjectsRequestingSupportList",
  // 	component: ProjectsRequestingSupportList,
  // 	layout: LayoutAdmin
  // },
  // {
  // 	exact: true,
  // 	path: "/ProjectOperationsReportList",
  // 	component: ProjectOperationsReportList,
  // 	layout: LayoutAdmin
  // },

  {
    exact: true,
    path: "/MaterialList",
    component: MaterialList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/BasicInformationList",
    component: BasicInformationList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectTimelineForm",
    component: ProjectTimelineForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProjectTimelineList",
    component: ProjectTimelineList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/SupplyTicket",
    component: SupplyTicket,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ReceiveTicketForm",
    component: ReceiveTicketForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/WithdrawTicketForm",
    component: WithdrawTicketForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/CommitteeList",
    component: CommitteeList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/CommitteeForm",
    component: CommitteeForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MaterialReceiveForm",
    component: MaterialReceiveForm,
    layout: LayoutAdmin,
  },
  {
    path: "/TicketSoldList",
    component: TicketSoldList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/TicketSoldForm",
    component: TicketSoldForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundActionPlan",
    component: FundActionPlanList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundActionPlanForm",
    component: FundActionPlanForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FollowUp",
    component: FollowUp,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ProgressReport",
    component: ProgressReport,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FollowUpReport",
    component: FollowUpReview,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FollowUpApprove",
    component: FollowUpApprove,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundPlanCalendar",
    component: FundPlanCalendar,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MaterialInventoryList",
    component: MaterialInventoryList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MaterialWithdrawForm",
    component: MaterialWithdrawForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/CommitteeTicketList",
    component: CommitteeTicketList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/CommitteeTicketForm",
    component: CommitteeTicketForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/AccountingPaymentList",
    component: AccountingPaymentList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/AccountingPaymentForm",
    component: AccountingPaymentForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/AccountingFundList",
    component: AccountingFundList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/AccountingFundForm",
    component: AccountingFundForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MaterialReturnForm",
    component: MaterialReturnForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MaterialWithdrawBorrowForm",
    component: MaterialWithdrawBorrowForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundIncomePlanList",
    component: FundIncomePlanList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundIncomePlanForm",
    component: FundIncomePlanForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundExpensePlanList",
    component: FundExpensesPlanList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundExpensePlanForm",
    component: FundExpensesPlanForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ReportIncomeExpense",
    component: ReportIncomeExpense,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/UserSystemList",
    component: UserSystemList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/UserSystemForm",
    component: UserSystemForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FunTest",
    component: FunTestcopy,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/EquipmentList",
    component: EquipmentList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/EquipmentReceiveForm",
    component: EquipmentReceiveForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/EquipmentWithdrawForm",
    component: EquipmentWithdrawForm,
    layout: LayoutAdmin,
  },
  {
    path: "/FundExpenseActualList",
    component: FundExpenseActualList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundExpenseActualForm",
    component: FundExpenseActualForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundIncomeActualList",
    component: FundIncomeActualList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundIncomeActualForm",
    component: FundIncomeActualForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/EquipmentReturnForm",
    component: EquipmentReturnForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/HomeAdmin",
    component: HomeAdmin,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ReportParcel",
    component: ReportParcel,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundPlanGanttChart",
    component: FundPlanGanttChart,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundActivityGraph",
    component: FundActivityGraph,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MigrateProject",
    component: MigrateProject,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/MigrationDataProject",
    component: MigrationDataProject,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/EquipmentCusoffForm",
    component: EquipmentCusoffForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundAccoutingList",
    component: FundAccoutingList,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/FundAccoutingForm",
    component: FundAccoutingForm,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/ReportTicketFund",
    component: ReportTicketFund,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/e-ticket",
    component: ETicket,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/e-ticket/import",
    component: ImportETicket,
    layout: LayoutAdmin,
  },
  {
    exact: true,
    path: "/changefile",
    component: ChangeFileTicketSold,
    layout: LayoutAdmin,
  },
];

export default route;
